import axiosInstance from "../../../utils/axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import { AxiosError } from "axios";
import { IConsentAuditResponse } from "../../../models/Interface/User.interface";
import { useAppQuery } from "../../querys/useAppQuery";

const useConsentAudit = (
  userId: string | undefined,
  consentId: number | undefined
) => {
  const { data, isLoading, isError, error, refetch, isFetching, isPending } =
    useAppQuery<IConsentAuditResponse, AxiosError<IErrorResponse>>({
      queryKey: [QueryKeys.CONSENT_AUDIT, { userId, consentId }],
      queryFn: async () => {
        return (
          await axiosInstance.get(
            `/users-consents/${userId}/audit/${consentId}`
          )
        ).data;
      },
      enabled: !!userId && !!consentId,
      staleTime: 0,
      retry: 0,
    });

  return { data, isLoading, isError, error, refetch, isFetching, isPending };
};

export default useConsentAudit;
